import { createStore } from 'redux'
import LocalStorageService from './services/LocalStorageService'

const cmia_data = LocalStorageService.obterItem('_pmpv-cmia')

const initialState = {
  sidebarShow: true,
  theme: cmia_data ? cmia_data.theme : 'default',
  jwt: cmia_data ? cmia_data.jwt : '',
  user: cmia_data ? cmia_data.user : '',
  authenticated: cmia_data ? cmia_data.authenticated : false,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
